export default __webpack_public_path__ + "static/media/planimg4.a3a70c40.png";